exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1DH8U{font-family:fontello-vod;font-style:normal;font-weight:400;speak:none;text-decoration:inherit;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}._37CwH{display:inline-flex;align-items:center;justify-content:center;border:1px solid #000;border-radius:50%}", ""]);

// exports
exports.locals = {
	"icon": "_1DH8U",
	"rounded-icon": "_37CwH",
	"roundedIcon": "_37CwH"
};